import { useState } from 'react';
import { Button } from '../button/Button';
import { respondToReport } from '../../api/witness';
import type { WitnessReportNotif } from '../../api/useGameEvents';
import styles from './Witness.module.css';

type Props = {
  code: string;
  token: string;
  report: WitnessReportNotif;
};

export function WitnessNotification({ code, token, report }: Props) {
  const [declining, setDeclining] = useState(false);
  const [reason, setReason] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const onAccept = async () => {
    setSubmitting(true);
    try {
      await respondToReport(code, token, report.reportId, true);
    } catch (err) {
      alert(err instanceof Error ? err.message : 'Failed');
      setSubmitting(false);
    }
  };

  const onDecline = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!reason.trim()) return;
    setSubmitting(true);
    try {
      await respondToReport(code, token, report.reportId, false, reason.trim());
    } catch (err) {
      alert(err instanceof Error ? err.message : 'Failed');
      setSubmitting(false);
    }
  };

  return (
    <div className={styles.notifOverlay}>
      <div className={styles.notifCard}>
        <p className={styles.notifTitle}>Witness report filed against you</p>
        <p className={styles.notifBody}>
          <strong>{report.reporterName ?? 'Someone'}</strong> reported you for attempting to murder{' '}
          <strong>{report.victimName ?? 'someone'}</strong>
          {report.weaponName ? (
            <>
              {' '}
              using <strong>{report.weaponName}</strong>
            </>
          ) : null}
          .
        </p>

        {!declining ? (
          <div className={styles.notifActions}>
            <Button onClick={onAccept} disabled={submitting}>
              Accept arrest
            </Button>
            <Button variant="secondary" onClick={() => setDeclining(true)} disabled={submitting}>
              Decline
            </Button>
          </div>
        ) : (
          <form onSubmit={onDecline} className={styles.declineForm}>
            <input
              className={styles.select}
              placeholder="Your reason for declining…"
              value={reason}
              onChange={(e) => setReason(e.target.value)}
              required
            />
            <div className={styles.notifActions}>
              <Button type="submit" disabled={submitting || !reason.trim()}>
                {submitting ? 'Sending…' : 'Send decline'}
              </Button>
              <Button variant="secondary" type="button" onClick={() => setDeclining(false)}>
                Back
              </Button>
            </div>
          </form>
        )}
      </div>
    </div>
  );
}
